import React from "react";
import styled from "styled-components";
import { Row, Column, Title, Button } from "../../../theme/index";
import steps from "../../../../assets/steps.png";

const Wrapper = styled.div`
  width: 100%;
  padding: 2em 0;
  @media (max-width: 1100px) {
    height: 100%;
    padding: 1em 0 2em 0;
  }
`;

const Img = styled.img`
  width: 85%;
  margin-bottom: 3em;
  @media (max-width: 1100px) {
    width: 95%;
  }
`;

const StyledRow = styled(Row)`
  margin: 1.5em 0 0 2em;
  @media (max-width: 1100px) {
    margin: 0 auto;
    justify-content: center;
  }
`;

export default function Steps({ navigate }) {
  return (
    <Wrapper>
      <StyledRow>
        <Title>How it works</Title>
      </StyledRow>
      <Column alignitems="center">
        <Img src={steps} alt="Steps img" />
        <Button primary onClick={() => navigate.push("/findce")}>
          Start your journey
        </Button>
      </Column>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Home/components/Steps.jsx